module.exports = __webpack_public_path__ + "static/media/10968f92.jpg";